import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, unref as _unref } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "doc-toast"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    key: 0,
    class: "documentPage"
};
const _hoisted_4 = { class: "tabBar" };
const _hoisted_5 = {
    key: 0,
    class: "tabContent"
};
const _hoisted_6 = {
    key: 0,
    class: "ai-overview"
};
const _hoisted_7 = { class: "ai-overview-header" };
const _hoisted_8 = ["src"];
const _hoisted_9 = { class: "ai-overview-text" };
const _hoisted_10 = {
    key: 1,
    class: "detailRows"
};
const _hoisted_11 = { class: "detailLabel" };
const _hoisted_12 = {
    key: 0,
    class: "detailValue"
};
const _hoisted_13 = ["onUpdate:modelValue"];
const _hoisted_14 = {
    key: 2,
    class: "editActions"
};
const _hoisted_15 = {
    key: 1,
    class: "tabContent"
};
const _hoisted_16 = { class: "section" };
const _hoisted_17 = { class: "subCategoryRow" };
const _hoisted_18 = { class: "subCategoryField" };
const _hoisted_19 = {
    key: 0,
    class: "detailRow"
};
const _hoisted_20 = { class: "detailValue" };
const _hoisted_21 = { class: "section" };
const _hoisted_22 = {
    key: 1,
    class: "detailRows"
};
const _hoisted_23 = { class: "detailRow" };
const _hoisted_24 = { class: "detailValue" };
const _hoisted_25 = { class: "detailRow" };
const _hoisted_26 = { class: "detailValue" };
const _hoisted_27 = { class: "detailRow" };
const _hoisted_28 = { class: "detailValue" };
const _hoisted_29 = { class: "detailRow" };
const _hoisted_30 = { class: "detailValue" };
const _hoisted_31 = {
    key: 1,
    class: "editActions"
};
const _hoisted_32 = { class: "section" };
const _hoisted_33 = { class: "previewHeader" };
const _hoisted_34 = { class: "previewLinks" };
const _hoisted_35 = {
    key: 0,
    class: "pdf-preview-placeholder"
};
const _hoisted_36 = ["src", "alt"];
const _hoisted_37 = {
    key: 2,
    class: "lastUpdated"
};
import { ref, computed, watch, onMounted, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useDocuments } from '@/composables/useDocuments';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import FieldDrawer from './elements/FieldDrawer.vue';
import InputSections from './elements/InputSections.vue';
import AiChatBanner from './elements/AiChatBanner.vue';
import VuePdfEmbed from 'vue-pdf-embed';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DocumentPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getDocument, getDocumentTypes, deleteDocument: doDeleteDocument, clearDocuments, updateDocument } = useDocuments();
        const documentId = ref(route.params.id);
        const document = ref(null);
        const wellData = ref([]);
        const editMode = ref(false);
        const activeTab = ref('summary');
        const selectedCategory = ref('');
        const selectedSubCategory = ref('');
        const selectedProvider = ref('');
        const documentTypes = ref([]);
        const categoryOptions = ref([]);
        const pdfError = ref(false);
        const previewLoaded = ref(false);
        const showToast = ref(false);
        const toastMessage = ref('');
        const loaded = ref(false);
        const aboutEditSections = ref([]);
        function processMonetaryAmounts(text) {
            if (localStorage.getItem('randomiseFigures') !== 'true')
                return text;
            const monetaryPattern = /(?:£|$)(?:\d{1,3}(?:,\d{3})*(?:\.\d{2})?|\d+(?:\.\d{2})?)|(?:\d+(?:\.\d{2})?\s*(?:pounds?|pence|p|GBP|USD))/gi;
            return text.replace(monetaryPattern, (match) => {
                if (match.startsWith('£') || match.startsWith('$'))
                    return match.charAt(0) + '####';
                return '####' + match.replace(/^\d+(?:\.\d{2})?/, '');
            });
        }
        function formattedTransactionDate(createdDateTime) {
            const date = new Date(createdDateTime);
            if (isNaN(date.getTime()))
                return 'Invalid Date';
            const day = String(date.getDate()).padStart(2, '0');
            const month = date.toLocaleString('default', { month: 'long' });
            const year = date.getFullYear();
            return `${day} ${month}, ${year}`;
        }
        function getDocumentCategoryImage(category) {
            const map = {
                'Home': require('@/assets/doc-categories/home.png'),
                'Family': require('@/assets/doc-categories/family.png'),
                'Banking': require('@/assets/doc-categories/banking.png'),
                'Investments': require('@/assets/doc-categories/investments.png'),
                'Vehicles': require('@/assets/doc-categories/vehicle.png'),
                'Travel': require('@/assets/doc-categories/travel.png'),
                'Work': require('@/assets/doc-categories/work.png'),
                'Tax': require('@/assets/doc-categories/tax.png'),
                'Health': require('@/assets/doc-categories/health.png'),
                'Subscriptions': require('@/assets/doc-categories/subscriptions.png'),
                'Personal': require('@/assets/doc-categories/personal.png'),
                'Pets': require('@/assets/doc-categories/pets.png'),
                'Important': require('@/assets/doc-categories/important.png'),
            };
            return map[category] || require('@/assets/doc-categories/other.png');
        }
        const docCategory = computed(() => {
            if (!document.value?.sysoDocumentType?.path)
                return '';
            const parts = document.value.sysoDocumentType.path.split(' > ');
            return parts[1] || '';
        });
        const docSubCategory = computed(() => {
            if (!document.value?.sysoDocumentType?.path)
                return '';
            const parts = document.value.sysoDocumentType.path.split(' > ');
            return parts[2] || '';
        });
        const maskedAiSummary = computed(() => {
            if (!document.value?.aiSummary)
                return '';
            return processMonetaryAmounts(document.value.aiSummary);
        });
        const subCategoryOptions = computed(() => {
            if (!selectedCategory.value || !documentTypes.value.length)
                return [];
            const subs = documentTypes.value
                .filter(t => t.path.split(' > ')[1] === selectedCategory.value && t.path.split(' > ')[2])
                .map(t => t.path.split(' > ')[2]);
            return [...new Set(subs)];
        });
        const categoryImage = computed(() => {
            return getDocumentCategoryImage(selectedCategory.value);
        });
        function onLoad() {
            getCustomer();
            getDocumentTypes((types) => {
                documentTypes.value = types;
                const uniqueCategories = [...new Set(types.map(t => t.path.split(' > ')[1]).filter(Boolean))];
                categoryOptions.value = uniqueCategories.map(name => ({
                    text: name,
                    value: name,
                    logo: getDocumentCategoryImage(name)
                }));
            });
            getDocument(documentId.value, (doc) => {
                document.value = doc;
                selectedCategory.value = docCategory.value;
                selectedSubCategory.value = docSubCategory.value;
                selectedProvider.value = doc.company || '';
                nextTick(() => { loaded.value = true; });
                wellData.value = doc.wellData.DataArray.map((item, index) => ({
                    order: index + 1,
                    label: item.Title,
                    value: item.Value
                }));
            });
        }
        function deleteDoc(done) {
            doDeleteDocument(documentId.value, () => {
                clearDocuments();
                if (done)
                    done();
                router.back();
            });
        }
        function onEdit() {
            aboutEditSections.value = [{
                    fields: [
                        { id: 'subject', type: 'text', label: 'Subject', value: document.value.documentSubject || '', required: false },
                        { id: 'description', type: 'text', label: 'Description', value: document.value.documentName || '', required: false },
                        { id: 'filename', type: 'text', label: 'File name', value: document.value.name || '', required: false },
                    ]
                }];
            activeTab.value = 'about';
            editMode.value = true;
        }
        function properCase(str) {
            if (!str)
                return '';
            return str.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
        }
        function onSaveAbout() {
            const fields = aboutEditSections.value[0]?.fields || [];
            fields.forEach((f) => {
                if (f.id === 'subject')
                    document.value.documentSubject = f.value;
                if (f.id === 'description')
                    document.value.documentName = f.value;
                if (f.id === 'filename')
                    document.value.name = f.value;
            });
            const payload = JSON.parse(JSON.stringify(document.value));
            updateDocument(payload, () => {
                editMode.value = false;
                toastMessage.value = 'Document updated';
                showToast.value = true;
                setTimeout(() => { showToast.value = false; }, 3000);
            });
        }
        function onCancelAbout() {
            editMode.value = false;
            selectedCategory.value = docCategory.value;
            selectedSubCategory.value = docSubCategory.value;
            getDocument(documentId.value, (doc) => {
                document.value = doc;
            });
        }
        function openDocument() {
            window.open(document.value.url, '_blank');
        }
        function onSave() {
            document.value.wellData.DataArray = wellData.value.map(item => ({
                Title: item.label,
                Value: item.value
            }));
            document.value.processedMeta = JSON.stringify(document.value.wellData);
            updateDocument(document.value, () => {
                editMode.value = false;
            });
        }
        watch(selectedCategory, (_, oldVal) => {
            if (oldVal)
                selectedSubCategory.value = '';
        });
        watch(selectedSubCategory, (val) => {
            if (val && loaded.value) {
                const matchingType = documentTypes.value.find(t => {
                    const parts = t.path.split(' > ');
                    return parts[1] === selectedCategory.value && parts[2] === val;
                });
                if (matchingType) {
                    document.value.sysoDocumentType = { ...matchingType };
                }
            }
        });
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_router_link = _resolveComponent("router-link");
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: document.value ? document.value.documentName : 'Document',
                    del: !editMode.value,
                    onDelete: deleteDoc,
                    edit: !editMode.value,
                    onEdit: onEdit,
                    menuDescription: "Update how this document is named, described or filed.",
                    menuEditLabel: "Edit details",
                    menuDeleteLabel: "Delete document"
                }, null, 8, ["title", "del", "edit"]),
                _createVNode(_Transition, { name: "toast-fade" }, {
                    default: _withCtx(() => [
                        (showToast.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("img", {
                                    src: require('@/assets/check-tick.svg'),
                                    class: "doc-toast-icon"
                                }, null, 8, _hoisted_2),
                                _createTextVNode(" " + _toDisplayString(toastMessage.value), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(CustomerLoadWait, { customer: document.value }, null, 8, ["customer"]),
                (document.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(AiChatBanner),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("button", {
                                class: _normalizeClass(['tab', { active: activeTab.value === 'summary' }]),
                                onClick: _cache[0] || (_cache[0] = ($event) => (activeTab.value = 'summary'))
                            }, "Summary", 2),
                            _createElementVNode("button", {
                                class: _normalizeClass(['tab', { active: activeTab.value === 'about' }]),
                                onClick: _cache[1] || (_cache[1] = ($event) => (activeTab.value = 'about'))
                            }, "About", 2)
                        ]),
                        (activeTab.value === 'summary')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                (document.value.aiSummary)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("img", {
                                                src: require('@/assets/aisummary.png'),
                                                class: "ai-marker"
                                            }, null, 8, _hoisted_8),
                                            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "ai-overview-title" }, "AI Overview", -1))
                                        ]),
                                        _createElementVNode("p", _hoisted_9, _toDisplayString(maskedAiSummary.value), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                (wellData.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wellData.value, (item) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                class: "detailRow",
                                                key: item.order
                                            }, [
                                                _createElementVNode("span", _hoisted_11, _toDisplayString(item.label), 1),
                                                (!editMode.value)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(processMonetaryAmounts(item.value)), 1))
                                                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                                                        key: 1,
                                                        class: "detailInput",
                                                        "onUpdate:modelValue": ($event) => ((item.value) = $event)
                                                    }, null, 8, _hoisted_13)), [
                                                        [_vModelText, item.value]
                                                    ])
                                            ]));
                                        }), 128))
                                    ]))
                                    : _createCommentVNode("", true),
                                (editMode.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        _createVNode(_component_v_row, { class: "button-row" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_col, { class: "button-col" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(MGButton, {
                                                            onClick: onSave,
                                                            text: "Save",
                                                            stacked: true
                                                        }),
                                                        _createVNode(MGButton, {
                                                            onClick: _cache[2] || (_cache[2] = ($event) => (editMode.value = false)),
                                                            outline: true,
                                                            stacked: true,
                                                            text: "Cancel"
                                                        })
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        (activeTab.value === 'about')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "sectionTitle" }, "Categorise this document", -1)),
                                    _createVNode(FieldDrawer, {
                                        modelValue: selectedCategory.value,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((selectedCategory).value = $event)),
                                        label: "Category",
                                        items: categoryOptions.value,
                                        required: true,
                                        clearable: false,
                                        disabled: !editMode.value
                                    }, null, 8, ["modelValue", "items", "disabled"]),
                                    _createElementVNode("div", _hoisted_17, [
                                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "subCategoryConnector" }, [
                                            _createElementVNode("div", { class: "connectorV" }),
                                            _createElementVNode("div", { class: "connectorH" })
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_18, [
                                            _createVNode(FieldDrawer, {
                                                modelValue: selectedSubCategory.value,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((selectedSubCategory).value = $event)),
                                                label: "Sub-category",
                                                items: subCategoryOptions.value,
                                                required: true,
                                                clearable: false,
                                                showAvatars: false,
                                                disabled: !editMode.value
                                            }, null, 8, ["modelValue", "items", "disabled"])
                                        ])
                                    ])
                                ]),
                                (selectedProvider.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "detailLabel" }, "Provider", -1)),
                                        _createElementVNode("span", _hoisted_20, _toDisplayString(properCase(selectedProvider.value)), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_21, [
                                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "sectionTitle" }, "Details", -1)),
                                    (editMode.value)
                                        ? (_openBlock(), _createBlock(InputSections, {
                                            key: 0,
                                            sections: aboutEditSections.value,
                                            theme: "light"
                                        }, null, 8, ["sections"]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                            _createElementVNode("div", _hoisted_23, [
                                                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "detailLabel" }, "Subject", -1)),
                                                _createElementVNode("span", _hoisted_24, _toDisplayString(document.value.documentSubject), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_25, [
                                                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "detailLabel" }, "Description", -1)),
                                                _createElementVNode("span", _hoisted_26, _toDisplayString(document.value.documentName), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_27, [
                                                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "detailLabel" }, "File name", -1)),
                                                _createElementVNode("span", _hoisted_28, _toDisplayString(document.value.name), 1)
                                            ])
                                        ])),
                                    _createElementVNode("div", _hoisted_29, [
                                        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "detailLabel" }, "Added on", -1)),
                                        _createElementVNode("span", _hoisted_30, _toDisplayString(document.value.createDateTimeString), 1)
                                    ])
                                ]),
                                (editMode.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                        _createVNode(_component_v_row, { class: "button-row" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_col, { class: "button-col" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(MGButton, {
                                                            onClick: onSaveAbout,
                                                            fullWidth: true,
                                                            text: "Save",
                                                            stacked: true
                                                        }),
                                                        _createVNode(MGButton, {
                                                            onClick: onCancelAbout,
                                                            outline: true,
                                                            fullWidth: true,
                                                            stacked: true,
                                                            text: "Cancel"
                                                        })
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("div", _hoisted_33, [
                                        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "sectionTitle" }, "Preview", -1)),
                                        _createElementVNode("div", _hoisted_34, [
                                            _createElementVNode("a", {
                                                class: "viewDocLink",
                                                onClick: openDocument
                                            }, "Download"),
                                            _createVNode(_component_router_link, {
                                                to: '/Documents/' + documentId.value + '/view',
                                                class: "viewDocLink"
                                            }, {
                                                default: _withCtx(() => _cache[19] || (_cache[19] = [
                                                    _createTextVNode("View")
                                                ])),
                                                _: 1
                                            }, 8, ["to"])
                                        ])
                                    ]),
                                    _createElementVNode("div", {
                                        class: "previewCard",
                                        onClick: _cache[9] || (_cache[9] = ($event) => (_unref(router).push('/Documents/' + documentId.value + '/view')))
                                    }, [
                                        (!previewLoaded.value || pdfError.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                                _createVNode(_component_v_icon, { class: "pdf-icon" }, {
                                                    default: _withCtx(() => _cache[21] || (_cache[21] = [
                                                        _createTextVNode("mdi-file-document-outline")
                                                    ])),
                                                    _: 1
                                                }),
                                                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "pdf-tap-text" }, "Tap to view", -1))
                                            ]))
                                            : _createCommentVNode("", true),
                                        (document.value.isPdf)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                (!pdfError.value)
                                                    ? (_openBlock(), _createBlock(_unref(VuePdfEmbed), {
                                                        key: 0,
                                                        source: document.value.url,
                                                        page: 1,
                                                        class: _normalizeClass(['pdf-preview', { 'preview-hidden': !previewLoaded.value }]),
                                                        onRendered: _cache[5] || (_cache[5] = ($event) => (previewLoaded.value = true)),
                                                        onRenderingFailed: _cache[6] || (_cache[6] = ($event) => (pdfError.value = true)),
                                                        onLoadingFailed: _cache[7] || (_cache[7] = ($event) => (pdfError.value = true))
                                                    }, null, 8, ["source", "class"]))
                                                    : _createCommentVNode("", true)
                                            ], 64))
                                            : (_openBlock(), _createElementBlock("img", {
                                                key: 2,
                                                src: document.value.url,
                                                alt: document.value.name,
                                                class: _normalizeClass(['image-preview', { 'preview-hidden': !previewLoaded.value }]),
                                                onLoad: _cache[8] || (_cache[8] = ($event) => (previewLoaded.value = true))
                                            }, null, 42, _hoisted_36))
                                    ])
                                ]),
                                (document.value.processedDateTime)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, " Last analysed: " + _toDisplayString(formattedTransactionDate(document.value.processedDateTime)), 1))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
